var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"d-flex flex-column align-center pa-4 mt-8",staticStyle:{"max-width":"600px"}},[_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }